import React from 'react';
import { Box, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import StarIcon from '@mui/icons-material/StarOutlineOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import { TBar, ABar } from './Widgets';
import { GlobalContext } from '../context/GlobalContextProvider';
import { Filter, FilterPrefs, FilterDrawer } from './Filter';
import { formatTime, formatAGRes, formatDateString,
    Runner, Finisher, getRunner, formatPB, getPBString, 
    eventIconText, sortKeys, ISNATIVE } from './Util';
import { MeetingListWithPopup } from './Meetings';
import '../Running.css';

interface SingleMeetingProps {
    finishers: {};
    meetingID: number;
    selRunnerID: string;
    showDescr: boolean;
}

interface SingleMeetingState {}

export class SingleMeeting extends React.Component<SingleMeetingProps, SingleMeetingState> {
    constructor(props: SingleMeetingProps) {
        super(props);
        this.state = { };
    }

    render() {
        const finishers: Record<string, Finisher> = this.props.finishers;
        var event_types: string[] = []
        var keys;

        var has_main_events = false;
        keys = sortKeys(finishers, [{key: 'Time', asc: true}, {key: 'Pos', asc: true}]);

        // Finds all events in the meeting
        for (var key in keys) {
            var fkey = keys[key]
            var fin: Finisher = finishers[fkey];

            if (event_types.indexOf(fin.Event) < 0) {
                event_types.push(fin.Event);
                if (fin.EType === 'PR' || fin.EType === 'R' || fin.EType === 'T' || fin.EType === 'MT')
                // if (ALL_EVENTS.indexOf(fin.Event) >= 0)
                    has_main_events = true;
            }
        }

        var tables: JSX.Element[] = [];
        for (var n=0; n<event_types.length; n++) {
            var date = '';
            var venue = '';
            var meeting = '';
            var event = '';
    
            var rows: JSX.Element[] = [];

            for (key in keys) {
                fkey = keys[key]
                fin = finishers[fkey];

                if (fin.Event !== event_types[n])
                    continue;

                if (fin) {
                    var runner = getRunner(fin.ID);
                    if (!runner)
                        continue
                } else {
                    console.log("Null finisher???")
                    continue
                }
    
                // var is_main_event = (ALL_EVENTS.indexOf(fin.Event) >= 0);
                var is_main_event = fin.EType === 'PR' || fin.EType === 'R' || fin.EType === 'T' || fin.EType === 'MT';

                if (date === '') {
                    date = fin.Date;
                    venue = fin.Venue;
                    meeting = fin.Meeting;
                    event = fin.Event;
                }

                var pb = formatPB(fin, false);
                var agres = is_main_event ? formatAGRes(fin.AGRes): '';

                rows.push(<tr key={key} data-key={fin.MeetingID} className={this.props.selRunnerID === fin.ID ? 'selectedrow' : ''}>
                        <td>{fin.Pos}</td>
                        <td><b>{runner.First + " " + runner.Last}</b></td>
                        <td><b>{formatTime(fin.Time, fin.Event)}</b></td>
                        { is_main_event && pb }
                        { is_main_event && <td>{agres}</td> }
                        <td>{fin.Gender + " " + fin.AG}</td>                        
                    </tr>);
            }

            if (this.props.showDescr) {
                var details = <table className='detailstable' key={meeting + event}>
                        <tbody>
                            <tr><td className='row-title'>{meeting}</td></tr>
                            <tr><td className='row-meta'>{formatDateString(date) + " | " + venue + " | " + event}</td></tr>
                        </tbody></table>
                tables.push(details);
            } else if (event_types.length > 1) {
                // always show the event name when there are multiple events in the same meeting
                details = <div className='row-title'>{event}</div>
                tables.push(details);
            }

            var head: JSX.Element = <div></div>;
            if (rows.length > 0) {
                if (has_main_events)
                    head = <tr><th>Pos</th><th>Name</th><th>Time</th><th></th><th colSpan={2}>AG</th></tr>;
                else
                    head = <tr><th>Pos</th><th>Name</th><th>Time</th><th>AG</th></tr>;
                tables.push(<table key={"trailer" + event} className='bicolortable'><thead>{head}</thead><tbody>{rows}</tbody></table>)
            }
        }

        return <div>{tables}</div>
    }
}

export function getFinisherCard(key: string, fin: Finisher, isOpen: boolean, 
                            onSelectRace: React.MouseEventHandler<HTMLDivElement>, variant: string) {
    var awards = getPBString(fin, false);
    var award_color = fin.PB === 2 ? 'var(--text-highlight)' : 'var(--text-highlight-2)';
    var [event_icon, event_text] = eventIconText(fin.Event, fin.EType);
    var datestr = formatDateString(fin.Date);
    var is_main_event = fin.EType === 'PR' || fin.EType === 'R' || fin.EType === 'T' || fin.EType === 'MT';
    var agres = is_main_event ? formatAGRes(fin.AGRes): '';

    var primary, secondary;
    if (variant === "normal") {
        primary = fin.Meeting;
        secondary = datestr + ' | ' + fin.Venue;
    } else {
        var runner = getRunner(fin.ID);
        primary = runner.First + " " + runner.Last;
        secondary = <> {datestr} | {fin.Meeting} | {fin.Venue} </>
    }

    return <div key={key}>
            <div
                className='gridcard card'
                style={{ gridTemplateColumns: 'minmax(auto,15fr) 75fr 10fr' }}
                onClick={onSelectRace}
                data-key={fin.MeetingID}
                data-runner-key={fin.ID}
            >
                <div style={{gridColumn: 1, gridRow: 1}} >{event_icon}</div>
                <div style={{gridColumn: 1, gridRow: 2}} >{event_text}</div>

                <div style={{gridColumn: 2, gridRow: 1}} >
                    <div style={{display: 'flex', flex: '1 1 100%', flexWrap: 'wrap', alignContent: 'center', columnGap: '5px'}}>
                    <div className='row-title' style={{flexGrow: 1, flexBasis: 'var(--field-width)'}}>{primary}</div>
                    <div className='row-meta' style={{flexGrow: 1, flexBasis: 'var(--field-width)'}}>{secondary}</div>                    </div>
                </div>
                <div style={{gridColumn: 2, gridRow: 2}} >
                    <div className='flexcard'>
                        <div style={{flex: '0 0', order: 1, borderRight: '1px solid var(--table-border-color)', paddingRight: '10px'}}>
                        <span className='text-muted'>Pos</span><br/>
                        <span className='text-primary' style={{fontSize: '1.6rem'}}>{fin.Pos}</span>
                        </div>
                        <div style={{flex: '0 0', order: 2, borderRight: '1px solid var(--table-border-color)', paddingRight: '10px'}}>
                        <span className='text-muted'>Time</span><br/>
                        <span className='text-primary' style={{fontSize: '1.6rem', fontWeight: 600}}>{formatTime(fin.Time, fin.Event)}</span>
                        </div>
                        <div style={{flex: '0 0', order: 3, borderRight: '1px solid var(--table-border-color)', paddingRight: '10px'}}>
                        <span className='text-secondary'>{fin.Gender + " " + fin.AG}</span><br/>
                        <span className='text-primary' style={{fontSize: '1.6rem'}}>{agres}</span>
                        </div>
                        <div style={{flex: '0 0', order: 4, color: award_color}}>{awards}</div>
                    </div>
                </div>
                <div className='chevron-muted' style={{gridColumn: 3, gridRow: 2}}><OpenInNewIcon fontSize="large" /></div>
            </div>
        </div>
}

export function getLeaderCard(runner: Runner, fin: Finisher, pos: number, variant: string, isOpen: boolean,
                            byVenue: boolean, onSelectRace: React.MouseEventHandler<HTMLDivElement>) {
    var compact = (variant === 'simple');
    var recordDrilldown = (variant === 'runner') || (variant === 'records');
    var cname = compact
        ? 'link leader-compact'
        : recordDrilldown
            ? `link runner-record-row ${isOpen ? 'runner-record-row-active' : ''}`
            : (isOpen ? 'link leader-compact' : 'card link');

    var pb = <></>
    if (fin.PB > 0) {
        var style = {}
        if (fin.PB === 2)
            style = {color: 'var(--text-highlight)'}
        else if (fin.PB === 1)
            style = {color: 'var(--text-highlight-2)'}
        pb = <StarIcon style={style} />
    }

    let venue_and_date;
    
    if (byVenue) {
        venue_and_date = <></>;
    } else {
        if (variant === "simple" || variant === "runner") {
            venue_and_date = fin.Venue;
        } else {
            venue_and_date = <div>
                                <div>{fin.Venue}</div>
                                <div>{formatDateString(fin.Date)}</div>
                            </div>
        }
    }

    var card = (
        <React.Fragment key={pos}>
            <div
                className={`${cname} leader-grid`}
                onClick={byVenue ? undefined : onSelectRace}
                data-key={fin.MeetingID}
                data-runner-key={runner.ID}
            >
                <div className="leader-pos">{byVenue ? fin.Pos : pos}</div>

                {variant === 'runner' ? (
                    <div className="leader-name">{formatDateString(fin.Date)}</div>
                ) : (
                    <div className="leader-name">{runner.First + " " + runner.Last}</div>
                )}

                <div className="leader-time">
                    {formatTime(fin.Time, fin.Event)}
                </div>

                <div className="leader-venue">
                    {venue_and_date}   
                </div>

                <div className="leader-ag">
                    <div>{pb}{fin.Gender + " " + fin.AG}</div>
                    <div>{formatAGRes(fin.AGRes)}</div>
                </div>
            </div>
        </React.Fragment>
    );
    return card;
}

interface ResultsPageProps {
    startRaceID?: string;
    navigateTo?: (path: string, replace?: boolean) => void;
}

interface ResultsPageState {
    filterquery: string;
    group_by: string;
}

export class ResultsPage extends  React.Component<ResultsPageProps, ResultsPageState> {
    static contextType = GlobalContext;

    constructor(props: ResultsPageProps) {
        super(props);
        this.state = {
            filterquery: '',
            group_by: 'M',
        }

        this.onChange = this.onChange.bind(this);
    }

    static filter_prefs: FilterPrefs = {year: true, month: true,
        event: true, all_event: true, mainOnly: false,
        gender: false, all_gender: false, age_group: false, all_age_group: false, meeting: true };

    componentDidMount() {
        this.onChange(new Filter(0, 0, '', '', '', false, ''), true);
    }

    onChange(filter: Filter, requery: boolean) { 
        var filterquery = '';
        if (filter.year > 0 || filter.event !== '' || filter.meeting.length > 2) {
            filterquery = "meeting=" + filter.meeting + "&year=" + filter.year + "&month=" + filter.month + "&event=" + filter.event; 
        }

        this.setState({ filterquery: filterquery, group_by: (filter.year > 0 && filter.month > 0) ? 'D' : 'M' });
    }

    openMenu = () => {
        const ctx = this.context as React.ContextType<typeof GlobalContext>;
        ctx.setMenuOpen(!ctx.menuOpen);
    }

    render() {
        // var filter = <FilterDrawer onChange={this.onChange} prefs={ResultsPage.filter_prefs} start_filter={new Filter(0, 0, '', '', '', false, '')} display_filter={true} />
        var filter = <FilterDrawer onChange={this.onChange} prefs={ResultsPage.filter_prefs} start_filter={new Filter()} display_filter={true} />

        var appbar = <div>
                        <ABar position="top" style={{top: ISNATIVE ? '35px' : '0'}}>
                            <TBar>
                                <IconButton sx={{ color: 'var(--paper-color)'}} onClick={this.openMenu}>
                                    <MenuIcon fontSize="large"></MenuIcon>
                                </IconButton>
                                <div className='largetext title-on-dark'>Results</div>
                                <Box sx={{ flexGrow: 1}} />
                                {filter}
                            </TBar>
                        </ABar>
                     </div>

      return <div>
                {appbar}

                <div style={{padding: '8px'}}>
                    <MeetingListWithPopup
                        key={this.state.filterquery} 
                        filter={this.state.filterquery} 
                        start_grouped={false} 
                        group_by={this.state.group_by}
                        print={false}
                        deepLinkBase="/races"
                        startRaceID={this.props.startRaceID}
                        navigateTo={this.props.navigateTo}
                    />
                </div>;
            </div>;
    }
}
